<div class="ds-grid ds-grid--3">
	<!-- Directive Examples -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Directive Usage</h3>
			<p class="ds-example__header-subtitle">Using eifTooltip directive for tooltip behavior</p>
		</div>
		<div class="ds-example__content">
			<div class="ds-group">
				<button
					eifTooltip="Top placement tooltip"
					eifTooltipPlacement="top"
					class="btn btn-sm btn-primary">
					Top
				</button>
				<button
					eifTooltip="Bottom placement tooltip"
					eifTooltipPlacement="bottom"
					class="btn btn-sm btn-primary">
					Bottom
				</button>
				<button
					eifTooltip="Left placement tooltip"
					eifTooltipPlacement="left"
					class="btn btn-sm btn-primary">
					Left
				</button>
				<button
					eifTooltip="Right placement tooltip"
					eifTooltipPlacement="right"
					class="btn btn-sm btn-primary">
					Right
				</button>
			</div>
			<div class="ds-group mt-3">
				<button
					eifTooltip="Click tooltip"
					eifTooltipTrigger="click"
					class="btn btn-sm btn-outline-primary">
					Click Me
				</button>
				<button
					eifTooltip="Delayed tooltip (1s)"
					eifTooltipDelay="1000"
					class="btn btn-sm btn-outline-primary">
					Delayed
				</button>
				<button
					eifTooltip="Disabled tooltip"
					eifTooltipDisabled="true"
					class="btn btn-sm btn-outline-primary">
					Disabled
				</button>
			</div>
		</div>
	</div>

	<!-- Basic Tooltips -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Component Usage</h3>
			<p class="ds-example__header-subtitle">Using eif-custom-tooltip component wrapper</p>
		</div>
		<div class="ds-example__content">
			<div class="ds-group">
				<eif-custom-tooltip content="Top placement tooltip">
					<eif-custom-button
						[text]="'Top'"
						[size]="'small'"></eif-custom-button>
				</eif-custom-tooltip>
				<eif-custom-tooltip
					content="Bottom placement tooltip"
					placement="bottom">
					<eif-custom-button
						[text]="'Bottom'"
						[size]="'small'"></eif-custom-button>
				</eif-custom-tooltip>
				<eif-custom-tooltip
					content="Left placement tooltip"
					placement="left">
					<eif-custom-button
						[text]="'Left'"
						[size]="'small'"></eif-custom-button>
				</eif-custom-tooltip>
				<eif-custom-tooltip
					content="Right placement tooltip"
					placement="right">
					<eif-custom-button
						[text]="'Right'"
						[size]="'small'"></eif-custom-button>
				</eif-custom-tooltip>
			</div>
		</div>
	</div>

	<!-- HTML Content -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">HTML Content</h3>
			<p class="ds-example__header-subtitle">Rich HTML content with formatting</p>
		</div>
		<div class="ds-example__content">
			<div class="ds-group">
				<button
					eifTooltip="<strong>Bold text</strong> and <em>italic text</em>"
					eifTooltipPlacement="top"
					class="btn btn-sm btn-info">
					HTML Directive
				</button>
				<eif-custom-tooltip
					[content]="htmlContent"
					placement="bottom">
					<eif-custom-button
						[text]="'HTML Component'"
						[size]="'small'"></eif-custom-button>
				</eif-custom-tooltip>
				<eif-custom-tooltip
					[content]="richContent"
					placement="right">
					<eif-custom-button
						[text]="'Rich Content'"
						[size]="'small'"></eif-custom-button>
				</eif-custom-tooltip>
			</div>
		</div>
	</div>

	<!-- Trigger Types -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Trigger Types</h3>
			<p class="ds-example__header-subtitle">Different ways to trigger tooltips</p>
		</div>
		<div class="ds-example__content">
			<div class="ds-group">
				<eif-custom-tooltip
					content="Hover to see tooltip"
					trigger="hover">
					<eif-custom-button
						[text]="'Hover'"
						[size]="'small'"></eif-custom-button>
				</eif-custom-tooltip>
				<eif-custom-tooltip
					content="Click to see tooltip"
					trigger="click">
					<eif-custom-button
						[text]="'Click'"
						[size]="'small'"></eif-custom-button>
				</eif-custom-tooltip>
				<eif-custom-tooltip
					content="Manual tooltip (use buttons below)"
					trigger="manual"
					#manualTooltip>
					<eif-custom-button
						[text]="'Manual'"
						[size]="'small'"></eif-custom-button>
				</eif-custom-tooltip>
				<div class="ds-group ds-group--inline">
					<eif-custom-button
						[text]="'Show'"
						[size]="'small'"
						[variant]="'outlined'"
						(click)="manualTooltip.show()"></eif-custom-button>
					<eif-custom-button
						[text]="'Hide'"
						[size]="'small'"
						[variant]="'outlined'"
						(click)="manualTooltip.hide()"></eif-custom-button>
				</div>
			</div>
		</div>
	</div>

	<!-- TemplateRef Content -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Template Content</h3>
			<p class="ds-example__header-subtitle">Using Angular templates for complex content</p>
		</div>
		<div class="ds-example__content">
			<div class="ds-group">
				<eif-custom-tooltip
					[content]="customTemplate"
					placement="top">
					<eif-custom-button
						[text]="'Template'"
						[size]="'small'"></eif-custom-button>
				</eif-custom-tooltip>
				<eif-custom-tooltip
					[content]="actionTemplate"
					placement="bottom">
					<eif-custom-button
						[text]="'Actions'"
						[size]="'small'"></eif-custom-button>
				</eif-custom-tooltip>
				<eif-custom-tooltip
					[content]="formTemplate"
					placement="left">
					<eif-custom-button
						[text]="'Form'"
						[size]="'small'"></eif-custom-button>
				</eif-custom-tooltip>
			</div>
		</div>
	</div>

	<!-- States and Options -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">States & Options</h3>
			<p class="ds-example__header-subtitle">Disabled tooltips and delays</p>
		</div>
		<div class="ds-example__content">
			<div class="ds-group">
				<eif-custom-tooltip
					content="Normal tooltip"
					placement="top">
					<eif-custom-button
						[text]="'Normal'"
						[size]="'small'"></eif-custom-button>
				</eif-custom-tooltip>
				<eif-custom-tooltip
					content="Disabled tooltip"
					[disabled]="true"
					placement="top">
					<eif-custom-button
						[text]="'Disabled'"
						[size]="'small'"></eif-custom-button>
				</eif-custom-tooltip>
				<eif-custom-tooltip
					content="Delayed tooltip (1s)"
					[delay]="1000"
					placement="top">
					<eif-custom-button
						[text]="'Delayed'"
						[size]="'small'"></eif-custom-button>
				</eif-custom-tooltip>
				<eif-custom-tooltip
					content="Auto placement"
					placement="auto">
					<eif-custom-button
						[text]="'Auto'"
						[size]="'small'"></eif-custom-button>
				</eif-custom-tooltip>
			</div>
		</div>
	</div>

	<!-- Container Options -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Container Options</h3>
			<p class="ds-example__header-subtitle">Body vs inline container positioning</p>
		</div>
		<div class="ds-example__content">
			<div class="ds-group">
				<eif-custom-tooltip
					content="Body container (default)"
					container="body">
					<eif-custom-button
						[text]="'Body'"
						[size]="'small'"></eif-custom-button>
				</eif-custom-tooltip>
				<eif-custom-tooltip
					content="Inline container"
					container="inline">
					<eif-custom-button
						[text]="'Inline'"
						[size]="'small'"></eif-custom-button>
				</eif-custom-tooltip>
			</div>
		</div>
	</div>

	<!-- Interactive Examples -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Interactive Examples</h3>
			<p class="ds-example__header-subtitle">Tooltips with interactive content</p>
		</div>
		<div class="ds-example__content">
			<div class="ds-group">
				<eif-custom-tooltip
					[content]="interactiveTemplate"
					placement="top"
					trigger="click">
					<eif-custom-button
						[text]="'Interactive'"
						[size]="'small'"></eif-custom-button>
				</eif-custom-tooltip>
				<eif-custom-tooltip
					[content]="progressTemplate"
					placement="bottom">
					<eif-custom-button
						[text]="'Progress'"
						[size]="'small'"></eif-custom-button>
				</eif-custom-tooltip>
				<eif-custom-tooltip
					[content]="chartTemplate"
					placement="right">
					<eif-custom-button
						[text]="'Chart'"
						[size]="'small'"></eif-custom-button>
				</eif-custom-tooltip>
			</div>
		</div>
	</div>
</div>

<!-- Templates for complex content -->
<ng-template #customTemplate>
	<div class="custom-tooltip-content">
		<h4>Custom Template</h4>
		<p>This is a template-based tooltip with <strong>rich content</strong> and <em>formatting</em>.</p>
		<div class="mt-2">
			<small class="text-muted">Created with Angular TemplateRef</small>
		</div>
	</div>
</ng-template>

<ng-template #actionTemplate>
	<div class="custom-tooltip-content">
		<h5>Actions</h5>
		<div class="d-flex flex-column gap-2">
			<eif-custom-button
				[text]="'Save'"
				[size]="'small'"
				[variant]="'outlined'"></eif-custom-button>
			<eif-custom-button
				[text]="'Cancel'"
				[size]="'small'"
				[variant]="'text'"></eif-custom-button>
		</div>
	</div>
</ng-template>

<ng-template #formTemplate>
	<div class="custom-tooltip-content">
		<h5>Quick Form</h5>
		<div class="form-group">
			<label class="form-label-sm">Name:</label>
			<input
				type="text"
				class="form-control form-control-sm"
				placeholder="Enter name" />
		</div>
		<div class="form-group">
			<label class="form-label-sm">Email:</label>
			<input
				type="email"
				class="form-control form-control-sm"
				placeholder="Enter email" />
		</div>
	</div>
</ng-template>

<ng-template #interactiveTemplate>
	<div class="custom-tooltip-content">
		<h5>Interactive Content</h5>
		<p>Click the buttons below:</p>
		<div class="d-flex gap-2">
			<eif-custom-button
				[text]="'Like'"
				[size]="'small'"
				[variant]="'outlined'"
				(click)="onLike()"></eif-custom-button>
			<eif-custom-button
				[text]="'Share'"
				[size]="'small'"
				[variant]="'outlined'"
				(click)="onShare()"></eif-custom-button>
		</div>
		<div class="mt-2">
			<small>Likes: {{ likeCount }} | Shares: {{ shareCount }}</small>
		</div>
	</div>
</ng-template>

<ng-template #progressTemplate>
	<div class="custom-tooltip-content">
		<h5>Progress Status</h5>
		<div
			class="progress"
			style="height: 10px">
			<div
				class="progress-bar"
				[style.width.%]="progressValue"></div>
		</div>
		<div class="mt-2">
			<small>Progress: {{ progressValue }}%</small>
		</div>
		<div class="mt-2">
			<eif-custom-button
				[text]="'Update'"
				[size]="'small'"
				[variant]="'outlined'"
				(click)="updateProgress()"></eif-custom-button>
		</div>
	</div>
</ng-template>

<ng-template #chartTemplate>
	<div class="custom-tooltip-content">
		<h5>Mini Chart</h5>
		<div
			class="d-flex align-items-end gap-1"
			style="height: 40px">
			<div
				class="bg-primary"
				style="height: 60%; width: 8px"></div>
			<div
				class="bg-primary"
				style="height: 80%; width: 8px"></div>
			<div
				class="bg-primary"
				style="height: 40%; width: 8px"></div>
			<div
				class="bg-primary"
				style="height: 90%; width: 8px"></div>
			<div
				class="bg-primary"
				style="height: 70%; width: 8px"></div>
			<div
				class="bg-primary"
				style="height: 50%; width: 8px"></div>
		</div>
		<div class="mt-2">
			<small>Sample data visualization</small>
		</div>
	</div>
</ng-template>
